import { capitalize } from "lodash";
import moment from "moment";
import React, { useState } from "react";

const BettingHistory = ({ data, key, betCheckObj }) => {
  const [active, setActive] = useState([]);
  console.log(data, "data");
  return data?.length > 0 ? (
    <tbody id="Matched_Content">
      {data?.map((item) => {
        return (
          <>
            <tr>
              <td>
                <span
                  style={{
                    color: "#2789ce",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {active.includes(item?._id) ? (
                    <img
                      style={{
                        height: "15px",
                        marginRight: "5px",
                      }}
                      onClick={() =>
                        setActive((prev) => {
                          return prev?.filter((res) => {
                            return res !== item?._id;
                          });
                        })
                      }
                      src={require("../../../assets/images/expand-open.png")}
                    />
                  ) : (
                    <img
                      style={{
                        height: "15px",
                        marginRight: "5px",
                      }}
                      onClick={() =>
                        setActive((prev) => {
                          return [...prev, item?._id];
                        })
                      }
                      src={require("../../../assets/images/expand-close.png")}
                    />
                  )}{" "}
                  {item?.matchBetId || item?.sessionBetId}
                </span>
              </td>
              <td>{item?.clientName}</td>
              <td
                style={{ textAlign: "start" }}
                className="text-start"
                width="30%"
              >
                <span style={{ textTransform: "uppercase" }}>
                  {betCheckObj[item?.eventType]}
                </span>
                <img
                  class="fromto"
                  src={require("../../../assets/images/transparent.gif")}
                />
                <strong>{item?.matchName}</strong>
                <img
                  class="fromto"
                  src={require("../../../assets/images/transparent.gif")}
                />
                {capitalize(item?.betFaireType) || item?.fancyName}
              </td>
              <td className="text-end">
                {" "}
                {key === "fancy"
                  ? item?.runnerName
                  : key === "Sportsbook"
                  ? item?.runnerName
                  : item?.teamName}
              </td>
              <td className="text-end">
                {" "}
                <span
                  className={
                    item?.betType == "lay" || item?.type == "No"
                      ? "lay-bg"
                      : item?.betType == "back" || item?.type == "Yes"
                      ? "back-bg"
                      : ""
                  }
                  style={{ textTransform: "capitalize" }}
                >
                  {item?.betType || item?.type}
                </span>
              </td>
              <td className="text-end">
                {moment(item?.timeInserted).format("YYYY-MM-DD hh:mm:ss")}
              </td>
              <td className="text-end">
                {" "}
                {key === "fancy"
                  ? item?.betRun + "/" + item?.bhav
                  : item?.bhav || "N/A"}
              </td>{" "}
              <td className="text-end"> {item?.amount || "N/A"}</td>
              <td className="text-end">
                {" "}
                {key === "fancy"
                  ? item?.betRun + "/" + item?.bhav
                  : item?.bhav || "N/A"}{" "}
              </td>
              {["Fancy", "bookmaker", "Exchange"].includes(key) ? (
                <td className="text-end">
                  {(item?.teamSelectionWin == item?.selectionId &&
                    item?.betType == "back") ||
                  (item?.teamSelectionWin != item?.selectionId &&
                    item?.betType == "lay") ? (
                    <span className="">{item?.profitAmount}</span>
                  ) : (
                    <span className="text-danger">({item?.loseAmount})</span>
                  )}
                </td>
              ) : key === "Sportsbook" ? (
                <td className="text-end">
                  {item?.teamSelectionWin &&
                  item?.teamSelectionWin
                    .split(",")
                    .includes(item?.fancySelectionId) ? (
                    <span className="">{item?.profitAmount?.toFixed(2)}</span>
                  ) : (
                    <span className="text-danger">
                      ({item?.loseAmount.toFixed(2)})
                    </span>
                  )}
                </td>
              ) : (
                <td className="text-end">
                  {item?.type == "No" ? (
                    item?.decisionRun < item?.betRun ? (
                      <span className="">{item?.profitAmount.toFixed(2)}</span>
                    ) : (
                      <span className="text-danger">
                        ({item?.loseAmount.toFixed(2)})
                      </span>
                    )
                  ) : item?.decisionRun >= item?.betRun ? (
                    <span className="">{item?.profitAmount.toFixed(2)}</span>
                  ) : (
                    <span className="text-danger">
                      ({item?.loseAmount.toFixed(2)})
                    </span>
                  )}
                </td>
              )}
            </tr>
            {active.includes(item?._id) && (
              <tr className="expand new-bethistory-slip" id={item?._id}>
                <td style={{ background: "#e2e8ed" }} colSpan={"2"}></td>
                <td
                  colSpan="9"
                  style={{ background: "#e2e8ed" }}
                  className="new-bethistory-slip-td"
                >
                  <img
                    class="expand-arrow"
                    src={require("../../../assets/images/transparent.gif")}
                  />
                  <table>
                    <tbody>
                      <tr>
                        <th>Bet Taken</th>
                        <th>Odds req.</th>
                        <th>Stake</th>
                        <th>Liability</th>
                        <th>Odds Matched</th>
                      </tr>
                      <tr
                        id="txRow0"
                        style={{ display: "table-row" }}
                        className="even"
                      >
                        <td className="text-end">
                          {moment(item?.timeInserted).format(
                            "YYYY-MM-DD hh:mm:ss"
                          )}
                        </td>
                        <td className="text-end">
                          {key === "fancy"
                            ? item?.betRun + "/" + item?.bhav
                            : item?.bhav || "N/A"}
                        </td>
                        <td className="text-end"> {item?.amount || "N/A"}</td>
                        <td className="text-end">
                          <span className="text-danger">
                            ({item?.loseAmount.toFixed(2)})
                          </span>
                        </td>
                        <td className="text-end">
                          {key === "fancy"
                            ? item?.betRun + "/" + item?.bhav
                            : item?.bhav || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            )}
          </>
        );
      })}
    </tbody>
  ) : (
    <tbody id="Matched_Content">
      <tr
        id="noDataTemplate"
        style={{
          display: "table-row",
        }}
      >
        <td className="no-data" colSpan="9">
          <p>You have no bets in this time period.</p>
        </td>
      </tr>
    </tbody>
  );
};

export default BettingHistory;
